module.exports = __webpack_public_path__ + "img/logo.b8c47554.svg";